<template>
  <div class="bonus-manage">
    <div class="bonus-header">
      <a-row :gutter="24" type="flex" align="top" class="select-container">
        <a-col>
          <span>费率类型 </span>
          <a-select
            v-model="queryParam.fundCode"
            show-search
            placeholder="请选择费率类型"
            style="width: 400px"
          >
            <a-select-option
              v-for="(item, index) in rate_type"
              :key="index"
              :value="item.title"
              @click="checkRateType(item)"
            >
              {{ item.title }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col>
          <a-button type="primary" @click="searchQuery"> 搜索 </a-button>
          <a-button type="primary" @click="searchReset">重置</a-button>
        </a-col>
      </a-row>
      <div class="mg">
        <a-button type="primary" icon="plus" @click="handleAdd">
          新增
        </a-button>
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item @click="batchDel"
              ><a-icon type="primary" />批量删除</a-menu-item
            >
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作 <a-icon type="down"
          /></a-button>
        </a-dropdown>
      </div>
    </div>
    <a-table
      ref="tableSelect"
      :columns="columns"
      rowKey="id"
      bordered
      :data-source="dataSource"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
      :pagination="ipagination"
      class="j-table-force-nowrap"
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑 </a>
        <a-divider type="vertical" />
        <a @click="handleDelete(record.id)">删除 </a>
      </span>
      <template slot="rate_type" slot-scope="text, record">
        <span v-for="(item, index) in rate_type" :key="index">
          <span v-if="record.rateType === item.value">
            {{ item.text }}
          </span>
        </span>
      </template>
      <template slot="isBracket" slot-scope="text, record">
        <span>{{ record.isBracket == 1 ? '是' : '否' }}</span>
      </template>
      <template slot="fee_type" slot-scope="text">
        <span v-for="(item, index) in fee_type" :key="index">
          <span v-if="text === item.value">
            {{ item.text }}
          </span>
        </span>
      </template>
    </a-table>

    <rate-manage-modal
      :fundList="fundList"
      :rate_type="rate_type"
      :fee_type="fee_type"
      ref="modalForm"
      @ok="modalFormOk"
    ></rate-manage-modal>
  </div>
</template>
<script>
import { ajaxGetDictItems } from '@/api/api';

import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import rateManageModal from './RateManageModal.vue';
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue';
import { getAction, postAction, postTag } from '@/api/manage.js';
const columns = [
  {
    title: '基金代码',
    dataIndex: 'fundCode',
    key: 'name',
    align: 'center'
  },
  {
    title: '基金名称',
    dataIndex: 'fundName',
    align: 'center'
  },
  {
    title: '费率类型',
    dataIndex: 'rateType_dictText',
    align: 'center'
  },
  {
    title: '计算方式',
    dataIndex: 'intervalType',
    align: 'center',

    customRender: text => {
      return text == 1 ? '固定型' : text == 2 ? '范围型' : '说明型';
    }
  },
  {
    title: '操作',
    dataIndex: '',
    key: 'x',
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
];

export default {
  name: 'BonusManage',
  mixins: [mixinDevice],
  components: {
    JDictSelectTag,
    rateManageModal
  },

  data() {
    return {
      fundInfo: {}, //产品信息
      typeList: [], //费率类型
      rateType: '',
      showDialog: false,
      fundCode: '',
      pageSize: 10,
      current: 1,
      confirmLoading: false,
      columns,
      selectedRowKeys: [],
      selectionRows: [],
      dataSource: [],
      rate_type: [],
      fee_type: [],
      fundList: [],
      superQueryParams: '',
      queryParam: {
        fundName: ''
      },
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      url: {
        list: process.env.VUE_APP_CMS_PRODUCT + '/product/rate/list', //费率结构列表
        delete: process.env.VUE_APP_CMS_PRODUCT + '/product/rate/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_PRODUCT + '/product/rate/deleteBatch',
        exportXlsUrl:
          process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/productsFundRate/exportXls',
        importExcelUrl:
          process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/productsFundRate/importExcel',
        productUrl:
          process.env.VUE_APP_CMS_PRODUCT + '/product/fund/list/reviewed'
      }
    };
  },
  created() {
    this.initData();

    this.$nextTick(() => {
      this.fundId = this.$route.query.fundId;
      this.getList();
    });
    this.productName();
  },
  methods: {
    //选择费率类型
    checkRateType(item) {
      this.rateType = item.value;
    },
    //费率类型
    initData() {
      getAction(
        process.env.VUE_APP_CMS_SYSTEM + `/sys/dict/getDictItems/rate_type`,
        {}
      ).then(res => {
        if (res.success) {
          this.rate_type = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    productName() {
      getAction(this.url.productUrl).then(res => {
        if (res.success) {
          this.fundList = res.result ? res.result : [];
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    upload() {
      this.showDialog = false;
    },
    // 查询
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = {
        rateType: this.rateType,
        pageNo: that.ipagination.current,
        pageSize: that.ipagination.pageSize,
        fundId: this.fundId ? this.fundId : this.$route.query.fundId //that.fundInfo.id,
      };
      postTag(that.url.list, params)
        .then(res => {
          that.loading = true;
          if (res.success) {
            that.dataSource =
              res.result && res.result.records ? res.result.records : [];
            that.loading = false;
            that.ipagination.total =
              res.result && res.result.total ? res.result.total : 0;
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    //获取点中的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    //添加
    handleAdd() {
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },

    // 编辑
    handleEdit(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '修改';
      this.$refs.modalForm.disableSubmit = false;
    },
    getQueryField() {
      var str = 'id,';
      this.columns.forEach(function(value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    //批量删除
    batchDel() {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function() {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.getList();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          }
        });
      }
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      console.warn(111111);
      this.getList(1);
    },
    //删除
    handleDelete(id) {
      let that = this;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function() {
          that.loading = true;
          let formdata = new FormData();
          formdata.append('id', id);
          formdata.append('fundCode', that.fundInfo.fundCode);
          that.$http.post(that.url.delete, formdata).then(res => {
            that.loading = false;
            if (res.success) {
              that.getList(1);
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
          });
        }
      });
    },
    //查询
    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      this.queryParam = {};
      this.rateType = '';

      if (this.$route.query.type != 4) {
        this.getList(1);
      }
    },
    //清空选中数据
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.getList();
    }
  }
};
</script>
<style lang="less" scoped>
.bonus-manage {
  background: #fff;
  padding: 25px;
  .bonus-header {
    .mg {
      margin: 20px 0;
    }
    button {
      margin-right: 10px;
    }
    .select-container {
      span {
        margin-right: 15px;
      }
    }
  }
}
</style>
